import * as React from 'react';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { getStartDateForSchoolYear } from 'Src/helpers/calendar/calendar';
import { getDefaultReportAgesForMultiSelect, getReportDefaultGendersForMultiSelect } from 'Src/helpers/multiselect/multiselect';
import { UnionSchoolReportForm } from '../UnionSchoolReportForm';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; }
export function UnionSchoolTargetCompletionReportForm({ onCloseClick, onSubmit }: Props) {
  const now = new Date();
  return <UnionSchoolReportForm
    initialValues={{ dateFrom: getStartDateForSchoolYear(now), dateTo: now, ageGroups: getDefaultReportAgesForMultiSelect(), genders: getReportDefaultGendersForMultiSelect(), isShowCompleted: true, isShowUncompleted: true, isShowBlank: true, isPrintFullNames: false, isSelectAllAges: true }}
    reportType={REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.UNION_SCHOOL_TARGET_COMPLETION}
    description="Review target completion across union schools for the selected period and audience."
    toggles={[
      { field: 'isShowCompleted', label: 'Completed targets', hint: 'Include targets that students have completed.' },
      { field: 'isShowUncompleted', label: 'Incomplete targets', hint: 'Include targets that are still incomplete.' },
      { field: 'isShowBlank', label: 'Schools with no matching data', hint: 'Keep schools without matching target activity in the report.' },
      { field: 'isPrintFullNames', label: 'Print full student names', hint: 'Use full names instead of abbreviated student details.' }
    ]}
    onCloseClick={onCloseClick} onSubmit={onSubmit}
  />;
}
